import Parse from 'parse';

export function initializeParse() {
    Parse.initialize(
        process.env.REACT_APP_ID || 'APP_ID',
        process.env.REACT_APP_JAVASCRIPT_KEY
    );
    Parse.serverURL = process.env.REACT_APP_SERVER_URL || '';
    Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
}